import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import {
	MOPLA_RIDES_TYPES_SEARCH_PARAM,
	MOPLA_RIDES_TYPES_SELECTED_CARD,
} from '@mopla/constants';
import { TripTypeEnum } from '@mopla/data-models';

export const useMoplaRideTypesControl = (selectedCard?: TripTypeEnum) => {
	const [searchParams, setSearchParams] = useSearchParams();

	const isOpened = searchParams.has(MOPLA_RIDES_TYPES_SEARCH_PARAM);

	const handleClose = useCallback(() => {
		setSearchParams((prevSearchParams) => {
			prevSearchParams.delete(MOPLA_RIDES_TYPES_SEARCH_PARAM);
			if (selectedCard)
				prevSearchParams.delete(MOPLA_RIDES_TYPES_SELECTED_CARD);
			return prevSearchParams;
		});
	}, [setSearchParams]);

	const handleOpen = useCallback(() => {
		setSearchParams((prevSearchParams) => {
			prevSearchParams.set(MOPLA_RIDES_TYPES_SEARCH_PARAM, '1');
			if (selectedCard)
				prevSearchParams.set(MOPLA_RIDES_TYPES_SELECTED_CARD, selectedCard);
			return prevSearchParams;
		});
	}, [setSearchParams]);

	return { isOpened, handleOpen, handleClose };
};
